import { EFormaPago } from "./formasPago";

export const CUPONERA = EFormaPago.CuponPago;
export const DEBITO_CBU = EFormaPago.DebitoConCBU;
export const DEBITO_TARJETA_CREDITO = EFormaPago.DebitoConTarjetaCredito;
